import CuratenieVileApartamente from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente";

export default function CuratenieVileApartamentePage() {
    return <CuratenieVileApartamente />;
}
